import React from 'react';
import './Loading.css';

export default function Loading() {
  return (
    <div className="loading-div-wrapper">
      <div className="loading-div">
        <img className="rotating-marble" src="../marble-css.png" />
      </div>
    </div>
  );
}
